<ng-container *ngIf="state$ | async; let state">
    <ng-container *ngIf="validity$ | async; let validity">
        <zbd-list
            label="Anlässe"
            itemName="Anlass"
            [collection]="state.protocol.OccasionOccasionEntries"
            [template]="event"
            [addFn]="addEntry(state.protocol)"
            [deleteFn]="deleteEntry()"
            [isRemovableFn]="isRemovableEntry()"
            [validity]="validity"
            [columnNumber]="2"
            class="zas-row"
        ></zbd-list>
    </ng-container>
</ng-container>

<ng-template #event let-item let-validity="validity">
    <div class="entry">
        <zbd-input
            type="checkbox"
            class="entry-input check"
            [name]="makeId('check', item.Id)"
            [entity]="item"
            property="ConsultingRequested"
            [updateFn]="persistence.updateOccasionOccasionEntry"
        ></zbd-input>
        <zbd-input
            type="text"
            class="entry-input text"
            [name]="item.Id"
            [entity]="item"
            property="OccasionName"
            [updateFn]="
                item.ManuallyAdded
                    ? persistence.updateOccasionOccasionEntry
                    : null
            "
            [validity]="validity"
        ></zbd-input>
    </div>
</ng-template>
